import axios from "axios";
import "../router";
import { authHeader } from "../helpers";

export const siteService = {
  addSite,
  deleteSite,
  submitSite,
  editSite,
  getSites,
  deleteBuilding,
  addBuilding,
  editBuilding,
  mail,
  userMail
};

function userMail(data) {
    // set the authentication header
    return axios
        .post(process.env.VUE_APP_AP_API + 'feedback/', data)
        .then(result => {
            return result;
        });
}

function mail(data) {
    // set the authentication header
    return axios
        .post(process.env.VUE_APP_AP_API + 'mail/', data)
        .then(result => {
            return result;
        });
}

function addSite({ address, latitude, longitude }) {
  // set the authentication header
  authHeader();
  return axios
    .post(process.env.VUE_APP_AP_API + process.env.VUE_APP_SITE_API, {
      address: address,
      LATITUDE: latitude,
      LONGITUDE: longitude
    })
    .then(result => {
      return result;
    });
}

function deleteSite({ site}) {
    // set the authentication header
    authHeader();

    //post this site
    return axios
        .delete(
            process.env.VUE_APP_AP_API + process.env.VUE_APP_SITE_API + site + "/"
        )
        .then(result => {
            return result;
        });
}

function submitSite({ site }) {
  // set the authentication header
  authHeader();

  return axios
    .post(process.env.VUE_APP_AP_API + process.env.VUE_APP_SUBMIT_API, site)
    .then(result => {
      //TODO check if this is working
      site["audit_id"] = result.data;
      site["inspection_status"] = "S";
      return axios
        .put(
          process.env.VUE_APP_AP_API + process.env.VUE_APP_SITE_API + site.id + "/",
          site
        )
        .then(result => {
          return result;
        });
    });
}

function deleteBuilding({ building}) {
    // set the authentication header
    authHeader();

    //post this site
    return axios
        .delete(
            process.env.VUE_APP_AP_API + process.env.VUE_APP_BUILDING_API + building + "/"
        )
        .then(result => {
            return result;
        });
}

function addBuilding({ site}) {
    // set the authentication header
    authHeader();

    //post this site
    return axios
        .post(
            process.env.VUE_APP_AP_API + process.env.VUE_APP_BUILDING_API  ,
            {
                site: site
            }
        )
        .then(result => {
            return result;
        });
}

function editSite({ site} ) {
  // set the authentication header
  authHeader();

  //post this site
  return axios
    .put(
      process.env.VUE_APP_AP_API + process.env.VUE_APP_SITE_API + site.id + "/",
        site
    )
    .then(result => {
      return result;
    });
}

function editBuilding({ building }) {
    // set the authentication header
    authHeader();

    //post this site
    return axios
        .put(
            process.env.VUE_APP_AP_API + process.env.VUE_APP_BUILDING_API + building.id + "/",
            building
        )
        .then(result => {
            return result;
        });
}

function getSites() {
  // set the authentication header
  authHeader();
  return axios
    .get(process.env.VUE_APP_AP_API + process.env.VUE_APP_CURRENT_USER_API)
    .then(result => {
      return result;
    });
}
